/**
 * Branded panel beside the auth forms. Hidden for now — flip to `true` to bring
 * it back; the markup and copy are kept in `AuthShell` rather than deleted.
 */
export const SHOW_AUTH_BRAND_PANEL = false;

/**
 * Prime-green primary button, shared by the auth screens (register, login,
 * email-verification notices). `btn-primary` sets its own background via
 * @apply outside any Tailwind layer, so plain utilities win or lose on
 * stylesheet order — the `!` modifier makes the override deterministic, and
 * every state is covered so hover doesn't flash back to blue.
 */
export const AUTH_GREEN_BUTTON_CLASSES =
  '!bg-[#0BAA84] hover:!bg-[#0A9977] focus-visible:!bg-[#0A9977] active:!bg-[#0A9977] disabled:!bg-[#0BAA84]/60';

export const TERMS_OF_USE_URL = 'https://www.primecc.com.au/terms-of-use/';
export const PRIME_CC_URL = 'https://www.primecc.com.au/';

/** Reassurance points on the branded panel — the old pages had none. */
export const AUTH_HIGHLIGHTS: { icon: string; label: string }[] = [
  { icon: '/icons/file-written.svg', label: 'Company, trust and SMSF documents in minutes' },
  { icon: '/icons/file-shield.svg', label: 'ASIC-compliant templates, kept current for you' },
  { icon: '/icons/scales.svg', label: 'Built for Australian accountants and advisers' },
];
